module.exports = __webpack_public_path__ + "static/media/Quam-Icon-Play.fac9cd67.svg";